// extracted by mini-css-extract-plugin
export var actionButton = "_jw-t";
export var buttonContainer = "_jw-0";
export var buttonContainer2 = "_jw-1";
export var buttonSection = "_jw-2";
export var details = "_jw-3";
export var dropdownItem = "_jw-5";
export var dropdownItemsContainer = "_jw-4";
export var fileInput = "_jw-r";
export var headerButton = "_jw-6";
export var icon = "_jw-7";
export var input = "_jw-8";
export var macroListItem = "_jw-9";
export var mainContent = "_jw-a";
export var microText = "_jw-b";
export var modal = "_jw-w";
export var optionsButton = "_jw-c";
export var paperclip = "_jw-s";
export var pillContent = "_jw-d";
export var preview = "_jw-e";
export var preview2 = "_jw-f";
export var quillEditor = "_jw-q";
export var selectedMacro = "_jw-g";
export var sidebar = "_jw-h";
export var sidebarHeader = "_jw-j";
export var sidebarList = "_jw-i";
export var sidebarListItem = "_jw-k";
export var sidebarSearch = "_jw-l";
export var snoozeDurationWrapper = "_jw-v";
export var statusPillContainer = "_jw-m";
export var tagsContainer = "_jw-n";
export var unselectedMacro = "_jw-o";
export var variable = "_jw-u";
export var wrapper = "_jw-p";